/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BuilderNavigationService } from '@gh/builder-shared';
import { LicenseAgreementType } from '@gh/builder-shared-data';
import { dictionaryValueFormatter, rendererIconByName, truthyCellRenderer } from '@gh/common-internal-shared';
import { AppRouter, EnumDictionary, getRouteInitData } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { GridDefinitionFactory, LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { LicenseAgreementListItem } from '../../resources/license-agreements.model';

@Component({
  selector: 'gh-license-agreement-list',
  template: require('./license-agreement-list.component.html'),
})
export class LicenseAgreementListComponent implements OnInit {
  licenseAgreements: LicenseAgreementListItem[];
  gridDefinition: LayoutBasedGridDefinition;
  licenseAgreementTypeDict: EnumDictionary<LicenseAgreementType>;

  constructor(private gridDefinitionFactory: GridDefinitionFactory,
              private router: AppRouter,
              private navigations: BuilderNavigationService,
              private route: ActivatedRoute) {
  }

  /**
   * Init component
   */
  ngOnInit(): void {
    const { gridLayout, licenseAgreements, licenseAgreementTypeDict } = getRouteInitData(this.route);

    this.licenseAgreementTypeDict = licenseAgreementTypeDict;

    this.licenseAgreements = licenseAgreements;

    this.gridDefinition = this.gridDefinitionFactory.buildLayoutBased(
      {
        systemRole: { valueFormatter: dictionaryValueFormatter(this.licenseAgreementTypeDict) },
        isActive: { cellRenderer: truthyCellRenderer(rendererIconByName('done')) },
      },
      {
        getRowNodeId: (item: LicenseAgreementListItem) => item.id,
      });
    this.gridDefinition.bind(gridLayout);
  }

  onCreate(): void {
    this.router.navigateToChild(['/setup/license-agreements/new']);
  }

  onEdit(id: ID): void {
    this.router.navigateToChild([`/setup/license-agreements/${id}`]);
  }

  goToAel(entityId?: ID): void {
    this.navigations.goToAel({
      entityId: entityId || void 0,
      entityType: 'LICENSE_AGREEMENT',
      label: 'lbl_license_agreements',
    });
  }
}
